// extracted by mini-css-extract-plugin
export default {"ticketNamePrice":"DQ_rts","description":"s4cuK5"};